import { render, staticRenderFns } from "./opportunities.vue?vue&type=template&id=c225df44&scoped=true&"
import script from "./opportunities.vue?vue&type=script&lang=js&"
export * from "./opportunities.vue?vue&type=script&lang=js&"
import style0 from "./opportunities.vue?vue&type=style&index=0&id=c225df44&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c225df44",
  null
  
)

export default component.exports